<template>
  <app-modal name="app-directory-modal" :title="title" @before-open="beforeOpen" @on-cancel="onCancel"  width="30%" @on-ok="onOk">
    <app-directory ref="directory" :edit="true"></app-directory>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppDirectory from '@/portal-components/directory-list';
import DirectoryProxy from '@/store/proxies/directory-proxy';
import { getDirectoryFlatStructure, getDirectoryOptions } from '@/utils/directory';

export default {
  name: 'AppDirectoryModal',
  components: {
    AppDirectory,
    AppModal,
  },
  data() {
    return {
      title: this.$t('directory.editDirectory'),
      originAppDirectory: null,
    };
  },
  mounted() {

  },
  methods: {
    onOk() {
      const directories = [];

      getDirectoryOptions(this.$refs.directory.dirData, (dir) => {
        directories.push({
          name: dir.name,
          id: dir.id,
          parent_id: dir.parentId,
        });
      });

      const dirStructure = getDirectoryFlatStructure();
      directories.forEach((dir) => {
        delete dirStructure[dir.id];
      });

      const payload = {
        structure: this.$refs.directory.dirData,
        directories,
        deletedDirectories: [
          ...Object.keys(dirStructure).map(id => parseInt(id, 0)),
        ],
      };

      new DirectoryProxy().updateDirTree(payload).then(() => {
        localStorage.setItem('directoryStructure', JSON.stringify(this.$refs.directory.dirData));
        this.$modal.hide('app-directory-modal', { isOk: true });
        this.$nextTick(() => {
          this.$bus.emit('refresh-app-directory');
        });
      });
    },
    onCancel() {
      localStorage.setItem('directoryStructure', this.originAppDirectory);
    },
    beforeOpen() {
      this.originAppDirectory = localStorage.getItem('directoryStructure');
    },
  },
};
</script>
<style scoped>
.form-control {
  border: none;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/directory-list/app-directory-modal.vue